import React, { useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback, AvRadioGroup, AvRadio, AvCheckboxGroup, AvCheckbox } from 'availity-reactstrap-validation';
import { Pagination, Autoplay, Navigation, Keyboard } from 'swiper/modules';
// import WOW from 'wowjs';
import { Parallax, useParallax } from 'react-scroll-parallax';
import { Link } from 'react-router-dom';
import HomeVideo from '../../assets/images/check-video.mp4';

export default function Service() {
    const swiperRef1 = useRef();

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <section className="inner-banner" style={{ position: 'relative', overflow: 'hidden' }}>
                <video
                    autoPlay
                    loop
                    muted
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: -1,
                    }}
                >
                    <source src={HomeVideo} type="video/mp4" />
                </video>
                <h1 className='heading'>Our Services</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className='star'><i className="fa fa-arrow-right"></i></li>
                        <li className="breadcrumb-item"><Link to="/services">Services</Link></li>
                    </ol>
                </nav>
            </section>


            <section className='about-section-4 bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(16, 18, 24)' }}>
                <div className='container-fluid'>
                    <div className='header-title header-center'>
                        {/* <h3 className='sub-heading'> OUR SERVICES</h3> */}
                        <h2 className='heading'>Security Testing Services</h2>
                        <p className='paragraph'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamco.</p>
                    </div>
                    <div className='row'>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to={"/services/network-penertration"}>
                                    <div className='thumb-img'>
                                        <img src="https://miro.medium.com/v2/resize:fit:900/1*T7qKoWPi4pNc8WjHglV9IQ.jpeg" alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>Network Penetration Testing</h4>
                                    <p className=''>Diagnosis is the key to find the root of the....</p>
                                    <Link to='/'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to="/services/web-application-penetration">
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/website-testing.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>Web Application Penetration Testing</h4>
                                    <p className=''>Expert Advice That Helps Mitigate Risk, and Maintain....</p>
                                    <Link to='/services/web-application-penetration'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to="/services/vulnerability-assessment">
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/vulnerability.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>Vulnerability Assessment & Penetration Testing</h4>
                                    <p className=''>Solutions designed to address the unique challenges and dynamics of rural consumer segments.</p>
                                    <Link to='/services/vulnerability-assessment'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to={"/services/mobile-app"}>
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/mobile-app-testing.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>Mobile App Penetration Testing</h4>
                                    <p className=''>Strategic placement and execution to maximize brand exposure and reach.</p>
                                    <Link to='/services/mobile-app'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to="/services/api-penetration">
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/api-presentation.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>API Penetration Testing</h4>
                                    <p className=''>Comprehensive merchandising solutions to optimize product presentation and visibility.</p>
                                    <Link to='/services/api-penetration'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to="/services/access-control">
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/access-control.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>Access Controls & Authorization Review</h4>
                                    <p className=''>Comprehensive merchandising solutions to optimize product presentation and visibility.</p>
                                    <Link to='/services/access-control'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='about-section-4 bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(15, 23, 42)' }}>
                <div className='container-fluid'>
                    <div className='header-title header-center'>
                        <h2 className='heading'>Cyber Risk Management</h2>
                        <p className='paragraph'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamco.</p>
                    </div>
                    <div className='row'>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to={"/services/iso-27001"}>
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/iso.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>ISO 27001 Consulting</h4>
                                    <p className=''>Diagnosis is the key to find the root of the....</p>
                                    <Link to='/services/iso-27001'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to="/services/sia-consulting">
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/nisa.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>SIA (NESA) Consulting</h4>
                                    <p className=''>Expert Advice That Helps Mitigate Risk, and Maintain....</p>
                                    <Link to='/services/sia-consulting'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to="/services/adhics-compliance">
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/compilance.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>ADHICS Compliance Consulting</h4>
                                    <p className=''>Solutions designed to address the unique challenges and...</p>
                                    <Link to='/services/adhics-compliance'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to={"/services/uae-information"}>
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/asurance.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>UAE Information Assurance Regulation Audit</h4>
                                    <p className=''>Strategic placement and execution to maximize brand...</p>
                                    <Link to='/services/uae-information'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to={"/services/sdlc-contulting"}>
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/sdlc.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>SDLC Consulting</h4>
                                    <p className=''>Our service empowers businesses to optimize their software development...</p>
                                    <Link to='/services/sdlc-contulting'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to={"/services/open-source"}>
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/open-source.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>Open Source Software Security Management</h4>
                                    <p className=''>Our service empowers businesses to optimize their software development...</p>
                                    <Link to='/services/open-source'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='about-section-4 bottom_100px top padding-left-right team-section-1' style={{ backgroundColor: 'rgb(16, 18, 24)' }}>
                <div className='container-fluid'>
                    <div className='header-title header-center'>
                        {/* <h3 className='sub-heading'> OUR SERVICES</h3> */}
                        <h2 className='heading'>Managed Services</h2>
                        <p className='paragraph'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamco.</p>

                    </div>
                    <div className='row'>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to={"/services/managed-security"}>
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/managed-security.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>Managed Security Services</h4>
                                    <p className=''>Diagnosis is the key to find the root of the....</p>
                                    <Link to='/services/managed-security'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to="/services/security-operations">
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/security-managed.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>Security Operations Centre</h4>
                                    <p className=''>Expert Advice That Helps Mitigate Risk, and Maintain....</p>
                                    <Link to='/services/security-operations'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4'>
                            <div className='service_box'>
                                <Link to="/services/annual-security">
                                    <div className='thumb-img'>
                                        <img src={require('../../assets/images/services/anual.webp')} alt='ser-1' />
                                    </div>
                                </Link>
                                <div className='service-detail-box'>
                                    <h4>Annual Security Program</h4>
                                    <p className=''>Solutions designed to address the unique challenges and dynamics of rural consumer segments.</p>
                                    <Link to='/services/annual-security'>Read more <i class="fa-solid fa-chevron-right"></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
